import api from './api';

export const getSearchParcelByReferenceNumber = (
  referenceNumber: string,
  postcode: string,
  recaptchaToken: string,
  origin: string
) => {
  return api.get({
    path: '/reference',
    headers: {
      'g-recaptcha-response': recaptchaToken,
    },
    query: {
      referenceNumber,
      postcode,
      origin: origin || 'PRTK',
    },
  });
};
